// Contract status enum — single source of truth for the frontend.
// Single-contract edits don't gate on status values (schema is TEXT, no
// CHECK), but the bulk endpoints validate against the backend mirror of this
// list. Order reflects the lifecycle:
//   draft → in_review → active → expired (or terminated at any point).
//
// When adding/removing a status:
//   - update backend/lib/enums.js CONTRACT_STATUSES (bulk endpoints + assistant)
//   - update StatusBadge.js (label, icon, colors)
//   - update ContractDetail.js timeline dot colors

export const CONTRACT_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'in_review', label: 'In Review' },
  { value: 'active', label: 'Active' },
  { value: 'expired', label: 'Expired' },
  { value: 'terminated', label: 'Terminated' },
];

// Filter-friendly variant with an "All" sentinel first. Used by list/filter UIs.
export const CONTRACT_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All Statuses' },
  ...CONTRACT_STATUSES,
];
